import { getStore } from '~/mobx/AppStore';
import { ZipCodeRangeForService } from '~/definitions/zipcode';
import { ZipCodeParser } from '~/utils/zipCodeParser';

const checkDuplicatedZipcode = async (zipCodesToAdd: ZipCodeRangeForService) => {
    const { zipcodeStore } = getStore();

    const stringifiedZipcode = ZipCodeParser.stringify([zipCodesToAdd]);

    const existing = zipcodeStore.existingZipcodeList;
    const duplicated = ZipCodeParser.findDuplicatedZipcode(stringifiedZipcode, existing).map((zip) =>
        String(zip).padStart(4, '0')
    );

    return duplicated;
};

export default checkDuplicatedZipcode;
